// extracted by mini-css-extract-plugin
export default {"video-card":"rzFABL","remove-padding":"O439EN"};